import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import i18next from 'i18next';
import axios from 'axios';
import { EyeIcon } from '@heroicons/react/24/solid';

export default function PreviewSlider({ carouselId, localhost, carouselScreen = "pc" }) {
  const { t } = useTranslation();
  const localimg = process.env.REACT_APP_LOCALHOST_IMG;
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [carousel, setCarousel] = useState(false);

  const handleGetCarousel = async () => {
    try {
      setIsOpen(true);
      const { data } = await axios.get(`${localhost}get-carousel/${carouselId}`);
      data.title = data.title ? JSON.parse(data.title) : null;
      data.details = data.details ? JSON.parse(data.details) : null;
      data.image = data.image ? localimg + data.image : null;
      setCarousel(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching carousel data:", error);
    }
  };

  return (
    <>
      {
        carouselScreen === "pc" ? (
          <button type="button" onClick={handleGetCarousel} className="rounded-md bg-black px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-black/90 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2">
            {t("preview")}
          </button>
        ) : (
          <button type="button" onClick={handleGetCarousel} className="text-black transition-colors duration-150 hover:bg-black/10 rounded-md p-1.5">
            <EyeIcon className='size-5' />
          </button>
        )
      }

      <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative z-50">
        <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" aria-hidden="true" />

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Dialog.Panel className="relative w-full max-w-5xl transform overflow-hidden rounded-xl bg-white shadow-2xl transition-all">
              <button onClick={() => setIsOpen(false)} className="absolute right-4 top-4 z-10 rounded-full bg-white/90 p-2 text-gray-800 hover:bg-white focus:outline-none">
                <XMarkIcon className="h-5 w-5" />
              </button>

              {
                loading ? (
                  <div className="min-h-[55vh] flex items-center justify-center">
                    <div className="loading-spinner" />
                  </div>
                ) : (
                  <div className="relative w-full" style={{ aspectRatio: "1920/960" }}>
                    <div className="absolute inset-0 bg-cover bg-center flex items-center justify-center" style={{ backgroundImage: `url(${carousel.image})` }}>
                      <div className="absolute inset-0 bg-black/40" />

                      <div className="relative z-10 text-center text-white px-4">
                        <h1 className="text-xl max-sm:text-xs font-bold mb-1 animate-fade-in">{carousel.title[i18next.language]}</h1>
                        <p className="text-sm max-sm:text-[9px] mb-3 max-sm:mb-1.5 max-w-2xl max-sm:max-w-[200px] leading-none mx-auto">{carousel.details[i18next.language]}</p>
                        <a href="/shop" className="bg-white text-black px-5 py-2 max-sm:px-3 max-sm:py-1.5 rounded-full text-xs max-sm:text-[8px] font-medium hover:bg-white/80 transition-colors duration-300">
                          {t("shop-now")}
                        </a>
                      </div>

                    </div>
                  </div>
                )
              }
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>
    </>
  );
}